/**
 * Keeping private work out of the dealership's report.
 *
 * The weekly and daily reports are sent to Melville. A private customer's car
 * must not appear in them — not as a section, and not folded into the grand
 * total either, which is the half that's easy to miss and impossible to spot
 * on a printed page.
 *
 * Plain CommonJS so the rule can be tested on its own:
 *   node frontend/test_report_split.js
 */

const isPrivateDept = (dept) => /^PRIVATE/i.test(String(dept || ''));

/**
 * @param {Object} sections  { 'KIA CARS': [row, …], PRIVATE: [row, …], … }
 * @returns {{ melville: Object, mTotal: {total:number,gst:number},
 *             private: Object,  pTotal: {total:number,gst:number},
 *             hasPrivate: boolean }}
 */
function splitPrivate(sections) {
  const melville = {}, priv = {};
  Object.entries(sections || {}).forEach(([dept, rows]) => {
    (isPrivateDept(dept) ? priv : melville)[dept] = rows || [];
  });
  const sum = (obj) => {
    let total = 0, gst = 0;
    Object.values(obj).forEach(rows =>
      (rows || []).forEach(r => {
        total += Number(r && r.total) || 0;
        gst   += Number(r && r.gst)   || 0;
      }));
    return { total, gst };
  };
  return {
    melville, mTotal: sum(melville),
    private: priv, pTotal: sum(priv),
    hasPrivate: Object.values(priv).some(rows => (rows || []).length > 0),
  };
}

module.exports = { splitPrivate, isPrivateDept };
